// Keep in sync with benchling/dev_platform/constants.py
export enum AvailabilityToShow {
  LA = 'la',
  GA = 'ga',
  NOT_AVAILABLE = 'not-available',
}

export enum AllowedVersions {
  V2_ALPHA = 'v2-alpha',
  V2_BETA = 'v2-beta',
  V2 = 'v2',
  V3_DRAFT = 'v3-draft',
  V3_ALPHA = 'v3-alpha',
  V3_BETA = 'v3-beta',
}
